import { createElement } from 'react';
import { ICONES_OBRA, medidasSpinner } from '@/lib/capitalSpinner';

interface Props {
    /** Diâmetro em px. Tela/painel 48 · bloco 32 · linha 24 · botão 16. */
    size?: number;
    /** Texto lido pelo leitor de tela. */
    label?: string;
    className?: string;
    /** `invertido` = círculo escuro com ícone laranja, para botão laranja (`btn-primary`). */
    tom?: 'padrao' | 'invertido';
}

/**
 * Spinner único da Capital — use este em toda espera com indicador (troca de
 * página, painel, botão rodando). Leitura de dado de tela continua skeleton
 * (`isPending`); ação do usuário continua `showLoadingAlert`, que mostra este
 * mesmo spinner.
 */
const CapitalSpinner = ({ size = 48, label = 'Carregando', className = '', tom = 'padrao' }: Props) => {
    const { icone, traco } = medidasSpinner(size);
    return (
        <span className={`cc-spinner ${tom === 'invertido' ? 'cc-spinner--invertido' : ''} ${className}`} role="status" aria-label={label} style={{ width: size, height: size }}>
            {ICONES_OBRA.map((nos, i) => (
                <svg key={i} width={icone} height={icone} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={traco} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    {nos.map(([tag, attrs], j) => createElement(tag, { key: j, ...attrs }))}
                </svg>
            ))}
        </span>
    );
};

export default CapitalSpinner;
